import { ApolloError } from '@apollo/client';
/**
 * An operation error that carries nothing but a message, for a test that only needs the call site
 * to see a failure and does not care what caused it.
 *
 * For tests, and for the same reason as {@link createGraphQLOperationError}. A test that branches
 * on the kind of error it got wants one of the other two.
 */
export const createOperationErrorWithMessage = (message) => new ApolloError({ errorMessage: message });
